import { paths } from '@luxuryescapes/contract-business'
import mapLoyaltyLinkedCreditAccount from 'api/mappers/loyalty/mapLoyaltyLinkedCreditAccount'
import requestUtils, { authOptions } from 'api/requestUtils'

type Response = paths['/api/business-traveller/businesses/{businessId}/loyalty/linkedAccount']['get']['responses']['200']['content']['application/json']

async function requestLoyaltyLinkedCreditAccount(businessId: string, token?: string) {
  const response = await requestUtils.get<Response>(`/api/business-traveller/businesses/${businessId}/loyalty/linkedAccount`, authOptions(token))

  return mapLoyaltyLinkedCreditAccount(response.result.accountSummary)
}

export default requestLoyaltyLinkedCreditAccount
